import { put, takeLatest } from "redux-saga/effects";
import { eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionIds, IKhongDuDieuKienKetQuaHocTapXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IKhongDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { khongDuDieuKienKetQuaHocTapXetTotNghiepApi } from "../../../api/xet-tot-nghiep/khongDuDieuKienKetQuaHocTapXetTotNghiepApi";

export function* khongDuDieuKienKetQuaHocTapXetTotNghiepSaga(): any {
    yield takeLatest(eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionIds.LOAD_BY_DOT_XET_START, selectByDotXetWorker);
}

export function* selectByDotXetWorker(action: IKhongDuDieuKienKetQuaHocTapXetTotNghiepActionTypes) {
    debugger;
    const id_dot_xet_tot_nghiep = action.payload as number;
    const response: IBaseResponse = yield khongDuDieuKienKetQuaHocTapXetTotNghiepApi.SelectByDotXet(id_dot_xet_tot_nghiep);
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.khongDuDieuKienKetQuaHocTapXetTotNghiep.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetTotNghiep.khongDuDieuKienKetQuaHocTapXetTotNghiep.LOAD_BY_DOT_XET_ERROR(response.message ?? "Lỗi khi tải danh sách không đủ điều kiện học tập"));
    }
}